// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Social section styles. */

.profile__section[data-profile-section='social'],
.profile__section--empty[data-profile-section='social'] {
  --social-card-collapsed-columns: repeat(5, max-content);
  --social-card-expanded-columns: repeat(3, max-content);
  --social-card-icon-size: var(--icon-base, 2rem);
  --social-card-list-display: flex;
  --social-card-list-columns: none;
  --social-card-list-gap: var(--spacing-xxs, 0.3125rem);
  --social-card-link-gap: var(--spacing-xs, 0.75rem);
  --social-card-link-padding: var(--spacing-xs, 0.75rem);
  --social-card-link-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff));
  --social-card-hidden-item-display: flex;
  --social-card-more-button-display: none;
  --social-card-more-button-margin-top: var(--spacing-xs, 0.75rem);
  border: var(--border-width-thin, 1px) solid var(--color-border-lighter, #D1D5DB);
}

.profile__section--empty[data-profile-section='social'] {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Card and list */
.social-card,
.social-card__list {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.social-card__list {
  display: var(--social-card-list-display);
  grid-template-columns: var(--social-card-list-columns);
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: var(--social-card-list-gap);
  margin: 0;
  padding: 0;
  list-style: none;
}

.social-card__item,
.social-card__link,
.profile__section--empty[data-profile-section='social'] .profile__empty-state-content {
  display: flex;
  align-items: center;
}

.profile__section--empty[data-profile-section='social'] .profile__empty-state-content {
  flex-direction: column;
  gap: var(--spacing-2xs, 0.625rem);
}

.social__empty-icon {
  display: inline-flex;
}

/* Links */
.social-card__link {
  color: var(--color-primary, #7C4DFF);
  text-decoration: none;
  gap: var(--social-card-link-gap);
  padding: var(--social-card-link-padding);
  border-radius: var(--border-radius-base, 0.3125rem);
  transition: background-color var(--animation-duration, 0.2s) ease;
  position: relative;
  flex: 1;
  min-width: 0;
}

.social-card__link:hover,
.social-card__link:focus {
  text-decoration: underline;
  background-color: var(--social-card-link-hover-background);
}

.social-card__link[href^="http"]:after {
  content: " (external link)";
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.social-card__icon {
  width: var(--social-card-icon-size);
  height: var(--social-card-icon-size);
  border-radius: var(--border-radius-base, 0.3125rem);
  background: var(--color-card-bg, #FFFFFF);
  flex-shrink: 0;
}

/* Toggle button */

solid-ui-button.social-card__more-button {
  --button-height-sm: 0;
  --button-padding-x-sm: 0;
  --button-background: transparent;
  --button-border: transparent;
  --button-text: var(--color-primary, #7C4DFF);
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary, #7C4DFF);
}

.social-card__more-button,
solid-ui-button.social-card__more-button::part(button) {
  display: var(--social-card-more-button-display);
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-primary, #7C4DFF);
  font: inherit;
  font-weight: var(--font-weight-bold, 600);
  cursor: var(--profile-interactive-cursor, pointer);
}

.social-card[data-mobile-expanded="false"] .social-card__item:nth-child(n + 11) {
  display: var(--social-card-hidden-item-display);
}

.social-card[data-mobile-expanded="true"] {
  --social-card-list-columns: var(--social-card-expanded-columns);
  --social-card-hidden-item-display: flex;
  --social-card-more-button-display: none;
}

/* Compact layout */
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section[data-profile-section='social'],
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section--empty[data-profile-section='social'] {
  --social-card-list-display: grid;
  --social-card-list-columns: var(--social-card-collapsed-columns);
  --social-card-hidden-item-display: none;
  --social-card-more-button-display: inline-flex;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .social-card .social-card__list {
  justify-content: flex-start;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section[data-profile-section='social'] .profile-section-collapsible__toggle-button,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section--empty[data-profile-section='social'] .profile-section-collapsible__toggle-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .social-card__more-button,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] solid-ui-button.social-card__more-button::part(button) {
  margin-top: var(--social-card-more-button-margin-top);
}

@media (max-width: 768px) {
  .profile__section[data-profile-section='social'],
  .profile__section--empty[data-profile-section='social'] {
    --social-card-list-display: grid;
    --social-card-list-columns: var(--social-card-collapsed-columns);
    --social-card-hidden-item-display: none;
    --social-card-more-button-display: inline-flex;
  }

  .social-card .social-card__list {
    justify-content: flex-start;
  }

  .social-card__more-button,
  solid-ui-button.social-card__more-button::part(button) {
    margin-top: var(--social-card-more-button-margin-top);
  }
}

@container profile-pane (max-width: 768px) {
  .profile__section[data-profile-section='social'],
  .profile__section--empty[data-profile-section='social'] {
    --social-card-list-display: grid;
    --social-card-list-columns: var(--social-card-collapsed-columns);
    --social-card-hidden-item-display: none;
    --social-card-more-button-display: inline-flex;
  }

  .social-card .social-card__list {
    justify-content: flex-start;
  }

  .social-card__more-button,
  solid-ui-button.social-card__more-button::part(button) {
    margin-top: var(--social-card-more-button-margin-top);
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/sections/social/SocialSection.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;;EAEE,uDAAuD;EACvD,sDAAsD;EACtD,+CAA+C;EAC/C,gCAAgC;EAChC,gCAAgC;EAChC,qDAAqD;EACrD,kDAAkD;EAClD,sDAAsD;EACtD,qGAAqG;EACrG,uCAAuC;EACvC,uCAAuC;EACvC,gEAAgE;EAChE,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,sDAAsD;EACtD,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,qBAAqB;EACrB,gCAAgC;EAChC,wCAAwC;EACxC,mDAAmD;EACnD,iEAAiE;EACjE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,mDAAmD;EACnD,yCAAyC;EACzC,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,4CAA4C;EAC5C,sCAAsC;EACtC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;;EAEE,+CAA+C;EAC/C,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+DAA+D;EAC/D,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;;EAEE,gCAAgC;EAChC,gEAAgE;EAChE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA;EACE;;IAEE,gCAAgC;IAChC,gEAAgE;IAChE,uCAAuC;IACvC,8CAA8C;EAChD;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,qDAAqD;EACvD;AACF;;AAEA;EACE;;IAEE,gCAAgC;IAChC,gEAAgE;IAChE,uCAAuC;IACvC,8CAA8C;EAChD;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,qDAAqD;EACvD;AACF","sourcesContent":["/* Social section styles. */\n\n.profile__section[data-profile-section='social'],\n.profile__section--empty[data-profile-section='social'] {\n  --social-card-collapsed-columns: repeat(5, max-content);\n  --social-card-expanded-columns: repeat(3, max-content);\n  --social-card-icon-size: var(--icon-base, 2rem);\n  --social-card-list-display: flex;\n  --social-card-list-columns: none;\n  --social-card-list-gap: var(--spacing-xxs, 0.3125rem);\n  --social-card-link-gap: var(--spacing-xs, 0.75rem);\n  --social-card-link-padding: var(--spacing-xs, 0.75rem);\n  --social-card-link-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff));\n  --social-card-hidden-item-display: flex;\n  --social-card-more-button-display: none;\n  --social-card-more-button-margin-top: var(--spacing-xs, 0.75rem);\n  border: var(--border-width-thin, 1px) solid var(--color-border-lighter, #D1D5DB);\n}\n\n.profile__section--empty[data-profile-section='social'] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Card and list */\n.social-card,\n.social-card__list {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.social-card__list {\n  display: var(--social-card-list-display);\n  grid-template-columns: var(--social-card-list-columns);\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: var(--social-card-list-gap);\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.social-card__item,\n.social-card__link,\n.profile__section--empty[data-profile-section='social'] .profile__empty-state-content {\n  display: flex;\n  align-items: center;\n}\n\n.profile__section--empty[data-profile-section='social'] .profile__empty-state-content {\n  flex-direction: column;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n.social__empty-icon {\n  display: inline-flex;\n}\n\n/* Links */\n.social-card__link {\n  color: var(--color-primary, #7C4DFF);\n  text-decoration: none;\n  gap: var(--social-card-link-gap);\n  padding: var(--social-card-link-padding);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  transition: background-color var(--animation-duration, 0.2s) ease;\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.social-card__link:hover,\n.social-card__link:focus {\n  text-decoration: underline;\n  background-color: var(--social-card-link-hover-background);\n}\n\n.social-card__link[href^=\"http\"]:after {\n  content: \" (external link)\";\n  position: absolute;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.social-card__icon {\n  width: var(--social-card-icon-size);\n  height: var(--social-card-icon-size);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  background: var(--color-card-bg, #FFFFFF);\n  flex-shrink: 0;\n}\n\n/* Toggle button */\n\nsolid-ui-button.social-card__more-button {\n  --button-height-sm: 0;\n  --button-padding-x-sm: 0;\n  --button-background: transparent;\n  --button-border: transparent;\n  --button-text: var(--color-primary, #7C4DFF);\n  --button-hover-background: transparent;\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary, #7C4DFF);\n}\n\n.social-card__more-button,\nsolid-ui-button.social-card__more-button::part(button) {\n  display: var(--social-card-more-button-display);\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--color-primary, #7C4DFF);\n  font: inherit;\n  font-weight: var(--font-weight-bold, 600);\n  cursor: var(--profile-interactive-cursor, pointer);\n}\n\n.social-card[data-mobile-expanded=\"false\"] .social-card__item:nth-child(n + 11) {\n  display: var(--social-card-hidden-item-display);\n}\n\n.social-card[data-mobile-expanded=\"true\"] {\n  --social-card-list-columns: var(--social-card-expanded-columns);\n  --social-card-hidden-item-display: flex;\n  --social-card-more-button-display: none;\n}\n\n/* Compact layout */\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section[data-profile-section='social'],\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section--empty[data-profile-section='social'] {\n  --social-card-list-display: grid;\n  --social-card-list-columns: var(--social-card-collapsed-columns);\n  --social-card-hidden-item-display: none;\n  --social-card-more-button-display: inline-flex;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .social-card .social-card__list {\n  justify-content: flex-start;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section[data-profile-section='social'] .profile-section-collapsible__toggle-button,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__section--empty[data-profile-section='social'] .profile-section-collapsible__toggle-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .social-card__more-button,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] solid-ui-button.social-card__more-button::part(button) {\n  margin-top: var(--social-card-more-button-margin-top);\n}\n\n@media (max-width: 768px) {\n  .profile__section[data-profile-section='social'],\n  .profile__section--empty[data-profile-section='social'] {\n    --social-card-list-display: grid;\n    --social-card-list-columns: var(--social-card-collapsed-columns);\n    --social-card-hidden-item-display: none;\n    --social-card-more-button-display: inline-flex;\n  }\n\n  .social-card .social-card__list {\n    justify-content: flex-start;\n  }\n\n  .social-card__more-button,\n  solid-ui-button.social-card__more-button::part(button) {\n    margin-top: var(--social-card-more-button-margin-top);\n  }\n}\n\n@container profile-pane (max-width: 768px) {\n  .profile__section[data-profile-section='social'],\n  .profile__section--empty[data-profile-section='social'] {\n    --social-card-list-display: grid;\n    --social-card-list-columns: var(--social-card-collapsed-columns);\n    --social-card-hidden-item-display: none;\n    --social-card-more-button-display: inline-flex;\n  }\n\n  .social-card .social-card__list {\n    justify-content: flex-start;\n  }\n\n  .social-card__more-button,\n  solid-ui-button.social-card__more-button::part(button) {\n    margin-top: var(--social-card-more-button-margin-top);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
